export const CONTACT_EMAIL = "contacto@globalfolio.com.uy";
export const CONTACT_PHONE = "+598 2518 2503";